jQuery(document).ready(function($) {

	var UTIL = {

		fire: function(func, funcname, args) {
			var namespace = DODGEBURN;
			funcname = (funcname === undefined) ? 'init' : funcname;
			if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function') {
				namespace[func][funcname](args);
			}
		},

		loadEvents: function() {
			var bodyId = document.body.id;
			var loaded = false;
			// hit up common first.
			UTIL.fire('common');

			// do all the classes too.
			$.each(document.body.className.split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, bodyId);
			});
		}

	},
	/** 
	 * Page-specific call-backs 
	 * Called after dom has loaded.  
	 */
	DODGEBURN = {

		common: {
			init: function() {
				console.info(' > DOM Ready > Init');
				$('html').removeClass('no-js').addClass('js');
				setTimeout(function() {
					if (!loaded) init();
				},
				2000);
				$(window).load(function() {
					if (!loaded) init();
				});
				searchPlaceholder();
				stickyHeader();
				checkURL();
				//initMC();
			}
		},

		templateIndex: {
			init: function() {
				console.info(' > Index Template');
				setupCycle('index');
				replaceImages();
			}
		},

		templateBlog: {
			init: function() {
				console.info(' > Blog');
				replaceImages();
			}
		},

		templatePage: {
			init: function() {
				console.info(' > Page');
				var masonry = $('.masonry');
				masonry.freetile().imagesLoaded(function(instance) {
					masonry.find(".item").last().css("marginRight", 0);
					masonry.freetile();
				});
				setupAccordion();
			}
		},

		templateCollection: {
			init: function() {
				console.info(' > Collection Template');
				$('.masonry').imagesLoaded(function(instance) {
					console.log($(this));
					$('.masonry').isotope({
						layoutMode: 'fitRows'
					});
				});
				/*$('.masonry').freetile().imagesLoaded( function( instance ) {
			  $(this).freetile({selector:'.item'});
		  });*/
				$('.color-icons').each(function() {
					var t = $(this);
					if (t.children().length > 1) t.show();
				})
			}
		},

		templateProduct: {
			init: function() {
				console.info(' > Product Template');
				$('#add').bind('click', addToCart);
				$(".popup").lightcase('init');
				var swatches = $("#swatches"),
					imgs = $("#product-images"),
					po = imgs.parent().offset().top,
					ph = imgs.parent().outerHeight();
					resizeImage();
					//scrollImage();
				
					$(".swatch.color", swatches).each(function() {
						var t = $(this);
						if(t.children("ul").children("li").length <= 1) {
							t.remove();
						}
					});
					if(swatches.children("div").length == 0) {
						$("h5.title", swatches.closest("form")).hide();
					}
				
				$(window).resize(function() {
					waitForFinalEvent(function() {
						resizeImage();
					},
					300, "wff_02");
				});
				
				/*$(window).scroll(scrollImage);

				function scrollImage() {
					if($(window).width() >= 640) {
						ph = t.parent().outerHeight();
						var s = $(this).scrollTop() + $("#top-nav").height() + 20,
							th = t.height();
						if (s > po && s - po < ph - th) {
							t.css('top', s - po);
						} else if (s <= po) {
							t.css('top', 0);
						} else {
							t.css('top', ph - th);
						}
					}
				}

				*/
				
				function resizeImage(tt) {
						vh = $(window).height() - $("#top-nav").height() - 40;
						tt = typeof tt !== 'undefined' ? tt : $("#product-images > .cycle > .slides > .current");
						//var ch = tt.find("img").height();
						if (vh >= 300 && $(window).width() >= 640) {
							$("#product-images").height(vh);
							tt.height(vh);
						} else {
							$("#product-images").height('auto');
						}
				}
				$('.cycle').each(function() {
					
					var show = $(this);
					var p = show;

					show.children('img,span,a').each(function(i) {
						$(this).wrap('<div class="slide" />');
					});
					
					var sh_inner = show.html();
					show.html('<div class="slides">' + sh_inner + '</div><div class="cycle-page"></div>');
					
					var con = show.children(".slides");

					show.find("img:first").load(function() {
						con.cycle({
							fx: 'fade',
							speed: 400,
							timeout: 8000,
							delay: 1000,
							next: $('.slides', p),
							pager: $('.cycle-page', p),
							slideExpr: '.slide',
							containerResize: 0,
							pause: true,
							sync: 1,
							width: "100%",
							fit: 1,
							slideResize: 1,
							after: function(curr, next) {
								
								$(next).addClass('current');
							},
							before: function(curr, next) {
								$(curr).removeClass('current');
							}
						});
					});
				});
			}
		},

		templateCart: {
			init: function() {
				console.info(' > Cart Template > Init');
				$('#toggle-note').toggle(
				function() {
					$('#checkout-addnote').find('textarea').show();
				},
				function() {
					$('#checkout-addnote').find('textarea').hide();
				});
				$("a.product-link").each(function() {
					t = $(this);
					link = parseUri(t.attr("href"));
					t.attr("href", link["domain"] + "/collections/shop" + link["path"]);
				});
			}
		}

	},

	loaded = false;

	UTIL.loadEvents();



	function init() {
		console.info(' > Window > Loaded');
		$("#main > .container > .masonry").css({
			visibility: "visible"
		});
		$("#main").css({
			visibility: "visible",
			opacity: 0
		}).animate({
			opacity: 1
		},
		400);
		loaded = true;
		atLoadAndResize();
	}



	function atLoadAndResize() {
		ch = $("#colophon").height();
		$("#main").css({
			paddingBottom: ch
		});
		$("#colophon").css({
			marginTop: -ch
		});
		$('.cycle').each(function() {
			var t = $(this);
			var h = t.find('.current').height();
			t.children(".slides").height(h)
		});

	}
	$(window).resize(function() {
		waitForFinalEvent(function() {
			atLoadAndResize();
		},
		300, "wff_01");
	});
	var waitForFinalEvent = (function() {
		var timers = {};
		return function(callback, ms, uniqueId) {
			if (!uniqueId) {
				uniqueId = "Don't call this twice without a uniqueId";
			}
			if (timers[uniqueId]) {
				clearTimeout(timers[uniqueId]);
			}
			timers[uniqueId] = setTimeout(callback, ms);
		};
	})();



	function stickyHeader() {
		// Sticky header for non-touch devices
		if (!Modernizr.touch) {
			var banner = $("#banner");
			var nav = $("#top-nav");
			var cart = $("#cart-icon");
			var nav_height = nav.height();
			var banner_height = banner.height();
			var fixed = false;
			$(window).scroll(function(e) {
				var win = $(this);
				var scrolltop = win.scrollTop();
				if (scrolltop >= banner_height) {
					if (!fixed) {
						nav.addClass("fixed").css("top", 0);
						cart.addClass("fixed");
						banner.css("marginBottom", nav.height());
					}
					fixed = true;
				} else if (scrolltop < banner_height) {
					if (fixed) {
						nav.removeClass("fixed");
						cart.removeClass("fixed");
						banner.css("marginBottom", 0);
					}
					fixed = false;
				}
			});
		}
	}



	function checkURL() {
		$('#top-nav > ul').find("li.current").parent("ul").parent("li").addClass("current");
	}



	function replaceImages() {
		$('.col_3 > figure.feature-image').each(function() {
			var fig = $(this);
			var img = fig.find('img:first');
			fig.css('background-image', 'url(' + img.attr("src") + ')').html('');
		});
	}



	function setupAccordion() {
		$('h4').each(function() {
			var $set = $();
			var nxt = this.nextSibling;
			while (nxt) {
				if (!$(nxt).is('h4') && !$(nxt).is('h5')) {
					$set.push(nxt);
					nxt = nxt.nextSibling;
				} else break;
			}
			$set.wrapAll('<div class="accordion-content" style="display:none" />');
		}).click(function() {
			$(this).next().slideToggle('fast');
			$(this).toggleClass("active");
			return false;
		}).next().hide();
	}



	function setupCycle(template) {
		$('.cycle').each(function() {
			var show = $(this);
			var p = show;
			if (show.children().filter('div, img,span,a').length > 1) {
				show.children('.slide').find('a').each(function(i) {
					t = $(this);
					src = t.find('img').attr('src');
					t.html('&nbsp;').css('background-image', 'url("' + src + '")');
				});
				var sh_inner = show.html();

				show.html('<div class="slides">' + sh_inner + '</div><div class="cycle-nav"><div id="prev" class="nav-link"><span class="icon">&lt;</span></div><div id="next" class="nav-link"><span class="icon">&gt;</span></div></div><div class="container" id="cycle-page-con"><div class="cycle-page"></div></div>');
				
				var con = show.children(".slides");

				con.cycle({
					fx: 'fade',
					speed: 600,
					timeout: 8000,
					delay: 1000,
					next: '#next',
					prev: '#prev',
					//pager:  $('.cycle-page', p),
					slideExpr: '.slide',
					containerResize: 0,
					sync: 1,
					width: "100%",
					fit: 1,
					after: function(el, next_el) {
						$(next_el).addClass('current');
					},
					before: function(el) {
						$(el).removeClass('current');
					}
				});

			}
		});
	}

	/** 
	 * Ajaxy add-to-cart 
	 */
	function addToCart(e) {

		if (typeof e !== 'undefined') e.preventDefault();

		var id = $(this).parents('form').find('[name="id"]').val();
		var quantity = $(this).parents('form').find('[name="quantity"]').val() || 1;

		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			async: false,
			cache: false,
			data: 'quantity=' + quantity + '&id=' + id,
			dataType: 'json',
			error: addToCartFail,
			success: addToCartSuccess,
			cache: false
		});

	}



	function addToCartSuccess(jqXHR, textStatus, errorThrown) {

		$.ajax({
			type: 'GET',
			url: '/cart.js',
			async: false,
			cache: false,
			dataType: 'json',
			success: updateCartDesc
		});
		var t = $('#add-to-cart-msg');
		t.stop().data('timer');
		t.removeClass('error').hide().html('Item added to cart!<br /><a href="/cart" title="view cart">View cart + checkout <span class="icon">&rarr;</span></a>').addClass('success').slideDown().data(this, 'timer', setTimeout(function() {
			t.slideUp();
		},
		5000));
	}



	function addToCartFail(jqXHR, textStatus, errorThrown) {
		var response = $.parseJSON(jqXHR.responseText);
		console.error('PROBLEM ADDING TO CART!', response.description);
		var t = $('#add-to-cart-msg');
		t.stop().data('timer');
		t.removeClass('success').hide().addClass('error').text(response.description).slideDown().data(this, 'timer', setTimeout(function() {
			t.slideUp();
		},
		5000));
	}



	function updateCartDesc(data) {
		var $cartLinkText = $('#cart-count');

		switch (data.item_count) {
		case 0:
			$cartLinkText.text('0');
			break;
		case 1:
			$cartLinkText.text('1');
			break;
		default:
			$cartLinkText.text(data.item_count);
			break;
		}
	}

	/** 
	 * Enable placeholder switcheroo in older browsers. 
	 * @see http://webdesignerwall.com/tutorials/cross-browser-html5-placeholder-text  
	 */
	function searchPlaceholder() {

		if (!Modernizr.input.placeholder) {
			$('#top-search-input').focus(function() {
				var input = $(this);
				if (input.val() == input.attr('placeholder')) {
					input.val('');
					input.removeClass('placeholder');
				}
			}).blur(function() {
				var input = $(this);
				if (input.val() == '' || input.val() == input.attr('placeholder')) {
					input.addClass('placeholder');
					input.val(input.attr('placeholder'));
				}
			}).blur();
			$('[placeholder]').parents('form').submit(function() {
				$(this).find('[placeholder]').each(function() {
					var input = $(this);
					if (input.val() == input.attr('placeholder')) {
						input.val('');
					}
				});
			});
		}
		$('[placeholder]').parents('form').find('label').hide();

	}



	function parseUri(sourceUri) {
		var uriPartNames = ["source", "protocol", "authority", "domain", "port", "path", "directoryPath", "fileName", "query", "anchor"],
			uriParts = new RegExp("^(?:([^:/?#.]+):)?(?://)?(([^:/?#]*)(?::(\\d*))?)((/(?:[^?#](?![^?#/]*\\.[^?#/.]+(?:[\\?#]|$)))*/?)?([^?#/]*))?(?:\\?([^#]*))?(?:#(.*))?").exec(sourceUri),
			uri = {};

		for (var i = 0; i < 10; i++) {
			uri[uriPartNames[i]] = (uriParts[i] ? uriParts[i] : "");
		}

		/* Always end directoryPath with a trailing backslash if a path was present in the source URI
		Note that a trailing backslash is NOT automatically inserted within or appended to the "path" key */
		if (uri.directoryPath.length > 0) {
			uri.directoryPath = uri.directoryPath.replace(/\/?$/, "/");
		}

		return uri;
	}



	function initMC() {
		$('#mc-embedded-subscribe').submit(function() {
			// update user interface
			$('#response').html('Adding email address...');

			// Prepare query string and send AJAX request
			$.ajax({
				url: '//bashirian-llc3436.myshopify.com/cdn/shop/t/5/assets/+%20store%20-%20address.php%20+?v=5',
				data: 'ajax=true&email=' + escape($('#email').val()),
				success: function(msg) {
					$('#response').html(msg);
					console.log(msg)
				}
			});

			return false;
		});
	}
});
